<!-- display-mobile-11 preview — a boxed in-article display ad on a publisher page -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
        <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

        <span class="da-adchoices d-flex align-items-center justify-content-center">
          <i class="bi bi-info-circle"></i>
        </span>
      </a>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-card d-flex flex-row align-items-center">
        <span class="da-brand">
          <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
          <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>
        </span>

        <div class="da-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>

        <!-- The mock's call to action is the arrow itself, so the authored text
             rides along as the accessible name rather than a visible label. -->
        <a
          [href]="data.url" target="_blank" rel="noopener noreferrer"
          class="da-cta d-flex align-items-center justify-content-center"
          [attr.aria-label]="data.ctaText || 'Your call to action'"
          [attr.title]="data.ctaText || 'Your call to action'"
        >
          <i class="bi bi-chevron-right"></i>
        </a>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
